import { render } from "./BlogPostView.vue?vue&type=template&id=3fd1a548&scoped=true"
import script from "./BlogPostView.vue?vue&type=script&lang=js"
export * from "./BlogPostView.vue?vue&type=script&lang=js"

import "./BlogPostView.vue?vue&type=style&index=0&id=3fd1a548&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3fd1a548"

export default script